import { fetchAuthSession } from 'aws-amplify/auth';

const handleAuditLogDump = async (email, startDate, endDate, setApiResponse, setConfirmModal, auditLogApiUrl) => {
    try {
        const { idToken } = (await fetchAuthSession()).tokens ?? {};
        const response = await fetch(auditLogApiUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${idToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                start: startDate,
                end: endDate
            })
        });

        if (response.status === 200) {
            setApiResponse(`Nice! Your audit log DB dump will be sent to your email (${email}) shortly.`);
        } else if (response.status === 400) {
            setApiResponse('You need to provide an email address.');
        } else if (response.status === 403) {
            setApiResponse(`Sorry, email (${email}) is not authorized to access this service! Please check with your administrator.`);
        } else if (response.status === 500) {
            setApiResponse('Internal server error occurred. Please check with your administrator.');
        } else {
            setApiResponse(`Unexpected response: ${response.status}`);
        }
    } catch (error) {
        console.error('Error calling audit log dump API:', error);
        setApiResponse('Failed to call audit log dump API');
    }
};

const handleSubmit = (email, startDate, endDate, setApiResponse, setConfirmModal, auditLogApiUrl) => {
    if (!email || !startDate || !endDate) {
        setApiResponse('Please fill in all required fields');
        setConfirmModal(true);
        return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        setApiResponse('Please enter a valid email address');
        setConfirmModal(true);
        return;
    }

    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return '';
        return dateTimeString.replace('T', ' ') + ':00';
    };

    const formattedStartDate = formatDateTime(startDate);
    const formattedEndDate = formatDateTime(endDate);

    if (new Date(endDate) <= new Date(startDate)) {
        setApiResponse('End date must be after start date');
        setConfirmModal(true);
        return;
    }

    setApiResponse('Processing your request...');
    setConfirmModal(true);

    handleAuditLogDump(email, formattedStartDate, formattedEndDate, setApiResponse, setConfirmModal, auditLogApiUrl);
};

const handleClose = (setConfirmModal) => {
    setConfirmModal(false);
};

export { handleAuditLogDump, handleSubmit, handleClose }; 